export default "__VITE_ASSET__CpvRDgBB__"